<template>
  <template v-if="current.raw_data.report_data.length > 0">
    <!-- План/факт проведения регламентных работ в разрезе количества элементов ТСО за отчетный период -->
    <Chart_1 v-if="current.guid === 'b5d7b1d3-0d39-11eb-8114-00155d01060e'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- План/факт проведения испытаний на объектах за отчетный период -->
    <Chart_2 v-else-if="current.guid === 'dc768591-0d39-11eb-8114-00155d01060e'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Время восстановления работоспособности -->
    <Chart_3 v-else-if="current.guid === 'cbdc5ef9-176d-11eb-8116-00155d01060e'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Время реакции на обращение -->
    <Chart_4 v-else-if="current.guid === 'be506b82-1769-11eb-8116-00155d01060e'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Распределение рабочего времени контракта по видам деятельности за отчетный период, в разрезе объектов -->
    <Chart_5 v-else-if="current.guid === '7dfb247e-0d48-11eb-8114-00155d01060e'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Распределение рабочего времени контракта по видам деятельности за отчетный период, в разрезе планов / фактов -->
    <Chart_6 v-else-if="current.guid === '3fd7613e-0de0-11eb-8114-00155d01060e'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Общее количество поступивших и устраненных инцидентов за отчетный период -->
    <Chart_7 v-else-if="current.guid === '00b83b6d-1770-11eb-8116-00155d01060e'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Незакрытые обращения в разрезе статусов и сторон -->
    <Chart_8 v-else-if="current.guid === '9e5d5835-e349-11ed-8761-c85acf022408'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Процент работоспособности КИТСО за отчетный период на объекте !!!! -->
    <Chart_9 v-else-if="current.guid === 'e932ea24-1cc5-11eb-8116-00155d01060e'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Показатели работоспособности КИТСО по объектам: Средняя работоспособность подсистем за отчетный период на объекте  !!!! -->
    <Chart_10 v-else-if="current.guid === 'f8c28d9e-1777-11eb-8116-00155d01060e'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Распределение аварийных обращений в разрезе причин аварийности -->
    <Chart_11 v-else-if="current.guid === '43929d70-0d26-11eb-8114-00155d01060e'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Динамика накопленным итогом зарегистрированных и закрытых аварийных обращений -->
    <Chart_12 v-else-if="current.guid === '1229589b-7d96-11eb-811b-00155d01060e'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Количество поступивших обращений не связанных с инцидентами за отчетный период -->
    <Chart_13 v-else-if="current.guid === '5577e2fc-815f-11eb-811b-00155d01060e'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Количество поступивших обращений не связанных с инцидентами по видам сервиса за отчетный период -->
    <Chart_14 v-else-if="current.guid === '43e8445a-e34a-11ed-8761-c85acf022408'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Количество обслуживаемых элементов ТСО в разрезе подсистем -->
    <Chart_15 v-else-if="current.guid === 'ab6140b1-7d95-11eb-811b-00155d01060e'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Количество поступивших обращений по объектам за отчетный период в разрезе подсистем -->
    <Chart_16 v-else-if="current.guid === 'cb6fc894-1449-11eb-8116-00155d01060e'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Приведенный коэффициент аварийности в разрезе подсистем -->
    <Chart_17 v-else-if="current.guid === '07fcd944-7ce5-11eb-811b-00155d01060e'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Приведенный коэффициент аварийности в разрезе подсистем -->
    <Chart_18 v-else-if="current.guid === '5ea47744-bf91-11eb-811e-00155d01060e'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Количество поступивших инцидентов за отчетный период в разрезе подсистем -->
    <Chart_19 v-else-if="current.guid === '70e72664-ddb0-11ed-8761-c85acf022408'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Количество поступивших инцидентов по объектам за отчетный период -->
    <Chart_20 v-else-if="current.guid === '88e0fa65-e328-11ed-8761-c85acf022408'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Распределение обращений по времени восстановления -->
    <Chart_21 v-else-if="current.guid === 'be00a980-b39f-11ee-8770-c85acf022408'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Распределение обращений по времени реакции -->
    <Chart_22 v-else-if="current.guid === '9a517f43-b39f-11ee-8770-c85acf022408'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Распределение обращений по времени реакции -->
    <Chart_23 v-else-if="current.guid === '0e51d701-b6c3-11ee-8770-c85acf022408'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Распределение инцидентов по времени реакции, зарегистрированных в нерабочее время  -->
    <Chart_24 v-else-if="current.guid === '6c88c8d5-c00d-11ee-8770-c85acf022408'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Распределение инцидентов по времени восстановления, зарегистрированных в нерабочее время -->
    <Chart_25 v-else-if="current.guid === 'ae341200-c00d-11ee-8770-c85acf022408'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Время реакции на обращение в нерабочее время -->
    <Chart_26 v-else-if="current.guid === '7b3de07e-2e37-11ef-8775-c85acf022408'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Время реакции на обращение в нерабочее время -->
    <Chart_27 v-else-if="current.guid === 'bae83bfe-2e37-11ef-8775-c85acf022408'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <!-- Отчёт план факт в разрезе типов работ НОВЫЙ -->
    <Chart_28 v-else-if="current.guid === '4f5eab8e-8a13-11ef-8778-c85acf022408'" :chart="current.raw_data" :uuid="uuid" :size="getSize()" :title="title" />
    <span v-else>Для графика {{ current.guid }} шаблона не представлено!</span>
  </template>
  <template v-else>
    Данные по отчёту отсутствуют, укажите в пояснительной записке причину!
  </template>

  <v-sheet color="grey" v-if="show_dev_fields">
    <pre>
      {{ current.raw_data }}
    </pre>
  </v-sheet>
</template>
<script>
import Chart_1 from "@/components/Reports/charts/b5d7b1d3-0d39-11eb-8114-00155d01060e"
import Chart_2 from "@/components/Reports/charts/dc768591-0d39-11eb-8114-00155d01060e"
import Chart_3 from "@/components/Reports/charts/cbdc5ef9-176d-11eb-8116-00155d01060e"
import Chart_4 from "@/components/Reports/charts/be506b82-1769-11eb-8116-00155d01060e"
import Chart_5 from "@/components/Reports/charts/7dfb247e-0d48-11eb-8114-00155d01060e"
import Chart_6 from "@/components/Reports/charts/3fd7613e-0de0-11eb-8114-00155d01060e"
import Chart_7 from "@/components/Reports/charts/00b83b6d-1770-11eb-8116-00155d01060e"
import Chart_8 from "@/components/Reports/charts/9e5d5835-e349-11ed-8761-c85acf022408"
import Chart_9 from "@/components/Reports/charts/e932ea24-1cc5-11eb-8116-00155d01060e"
import Chart_10 from "@/components/Reports/charts/f8c28d9e-1777-11eb-8116-00155d01060e"
import Chart_11 from "@/components/Reports/charts/43929d70-0d26-11eb-8114-00155d01060e"
import Chart_12 from "@/components/Reports/charts/1229589b-7d96-11eb-811b-00155d01060e"
import Chart_13 from "@/components/Reports/charts/5577e2fc-815f-11eb-811b-00155d01060e"
import Chart_14 from "@/components/Reports/charts/43e8445a-e34a-11ed-8761-c85acf022408"
import Chart_15 from "@/components/Reports/charts/ab6140b1-7d95-11eb-811b-00155d01060e"
import Chart_16 from "@/components/Reports/charts/cb6fc894-1449-11eb-8116-00155d01060e"
import Chart_17 from "@/components/Reports/charts/07fcd944-7ce5-11eb-811b-00155d01060e"
import Chart_18 from "@/components/Reports/charts/5ea47744-bf91-11eb-811e-00155d01060e"
import Chart_19 from "@/components/Reports/charts/70e72664-ddb0-11ed-8761-c85acf022408"
import Chart_20 from "@/components/Reports/charts/88e0fa65-e328-11ed-8761-c85acf022408"
import Chart_21 from "@/components/Reports/charts/be00a980-b39f-11ee-8770-c85acf022408"
import Chart_22 from "@/components/Reports/charts/9a517f43-b39f-11ee-8770-c85acf022408"
import Chart_23 from "@/components/Reports/charts/0e51d701-b6c3-11ee-8770-c85acf022408"
import Chart_24 from "@/components/Reports/charts/6c88c8d5-c00d-11ee-8770-c85acf022408"
import Chart_25 from "@/components/Reports/charts/ae341200-c00d-11ee-8770-c85acf022408"
import Chart_26 from "@/components/Reports/charts/7b3de07e-2e37-11ef-8775-c85acf022408"
import Chart_27 from "@/components/Reports/charts/bae83bfe-2e37-11ef-8775-c85acf022408"
import Chart_28 from "@/components/Reports/charts/4f5eab8e-8a13-11ef-8778-c85acf022408"
import {ShowDevVields} from "@/store/report/show_dev.store";

export default {
  name: "ChartHandler",
  components: {
    Chart_1, Chart_2, Chart_3, Chart_4, Chart_5, Chart_6, Chart_7, Chart_8, Chart_9, Chart_10,
    Chart_11, Chart_12, Chart_13, Chart_14, Chart_15, Chart_16, Chart_17, Chart_18, Chart_19,
    Chart_20, Chart_21, Chart_22, Chart_23, Chart_24, Chart_25, Chart_26, Chart_27, Chart_28
  },
  props: ['current', 'pattern', 'title', 'index', 'mode'],
  computed: {
    uuid() {
      return this.current.uuid
    },
    show_dev_fields: {
      get() {
        return ShowDevVields().get()
      },
      set(value) {
        return ShowDevVields().set(value)
      }
    }
  },
  methods: {
    getMultipageHeight: function () {
      return this.$rep_cfg.charts.find(chart => chart.guid === this.current.guid).height + 'px'
    },
    getSize: function () {
      let scales
      let patt = this.pattern
      if (this.mode === 'print' || this.mode === 'edit') {
        patt = patt.split('_')
        let modification = this.$rep_cfg.patterns.find(pattern => pattern.name === patt[0]).modifications.find(modifiacation => modifiacation.name === patt[1])
        scales = {
          width: modification.locations.charts[this.index].html_scales.w+'px',
          height: patt[0] === 'multipage' ? this.getMultipageHeight() : modification.locations.charts[this.index].html_scales.h+'px'
        }
      } else {
        scales = {
          width: 'auto',
          height: 'auto'
        }
      }
      return scales
    }
  }
}
</script>

<style scoped>

</style>
